// extracted by mini-css-extract-plugin
export default {"buttonText":"MRMAA","iconShown":"zhXIm","loadingSpinner":"Brt5_"};